import React from "react";
import { VMProvider } from "../commons/base/providers/provider";
import Scaffold from "../commons/scaffold/scaffold";
import SoldOutCmsEditorViewModel from "./view_models/sold_out_cms_editor_view_model";
import SoldOutCmsDeleteMenu from "./widgets/sold_out_cms_delete_menu";
import SoldOutCmsFilterWidget from "./widgets/sold_out_cms_filter_widget";
import SoldOutCmsModalWidget from "./widgets/sold_out_cms_modal_widget";
import SoldOutCmsTableWidget from "./widgets/sold_out_cms_table_widget";

export default class SoldOutCMSEditorEquipment extends React.Component {
    static path = "/sold-out-cms/equipment";

    render(): React.ReactNode {
        return (
            <VMProvider create={() => new SoldOutCmsEditorViewModel()}>
                {(vm) => (
                    <Scaffold
                        isShowLoading={vm.isLoading}
                        loadingBackgroundType="semi_transparent"
                        showErrorView={vm.errorModel}
                        showSnackbar={vm.snackbarModel}
                    >
                        <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-10 relative">
                            <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                                Sold Out CMS Editor Equipment
                            </h1>

                            <SoldOutCmsFilterWidget />
                            <SoldOutCmsTableWidget caseType={"equipment"} />
                            {(vm.isShowingModal && vm.isDeleteOptionDisabled) && <SoldOutCmsModalWidget />}
                            {(vm.isShowingModal && !vm.isDeleteOptionDisabled) && <SoldOutCmsDeleteMenu />}

                            {/* Create New Button */}
                            {/* <div className="fixed bottom-4 right-4">
                                <button
                                    className="px-4 py-4 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
                                    onClick={() => vm.openModalForCreate()}
                                >
                                    Create New
                                </button>
                            </div> */}
                        </div>
                    </Scaffold>
                )}
            </VMProvider>
        );
    }
}
